module.exports = __webpack_public_path__ + "img/jboard_icon-46.bb7c2e4d.png";